export default __webpack_public_path__ + "static/media/icons8-hand-plane.a8b85f8a.svg";